export default __webpack_public_path__ + "static/media/qh.9438eb7d.png";